// auth.js

import Cookies from 'js-cookie'
import jwt from 'jwt-decode'

const TokenKey = 'sytoken_center3'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    const jwtObj = jwt(token)
    return Cookies.set(TokenKey, token, {
        expires: new Date(jwtObj.exp * 1000)
    })
}

export function removeToken() {
    Cookies.set(TokenKey, '')
    // return Cookies.remove(TokenKey)
}

export const loginState = {
    state: [],
    dispatchState() {
        const key = Array.prototype.shift.call( arguments );
        const fns = this.state[key];
        if (!fns || fns.length === 0) {
            return false;
        }
        for (let i = 0; i < fns.length; i++) {
            const fn = fns[i]
            fn.apply( this, arguments)
        }
    },
    watchState(key, fn) {
        if (!this.state[key]) {
            this.state[key] = []
        }
        this.state[key].push(fn)
    }
}
